<template>
  <div class="hub-running-dispatching">
    <div class="left">
      <div v-html="hubStatusText" class="title"></div>
      <div v-html="hubStatusDesc" class="desc"></div>
    </div>
    <div>
      <img src="../../../assets/img-v2/ic_order_wait_stop.png" class="stop" />
      <img src="../../../assets/img-v2/ic_order_wait_bus.png" class="bus" />
    </div>

    <HubOrderCancelModal
      v-model="showCancelModal"
      :isRouteToHome="!isDispatching"
    >
      {{ hubCancelModalDesc }}
    </HubOrderCancelModal>
  </div>
</template>

<script>
import HubOrderCancelModal from "./HubOrderCancelModal.vue";

export default {
  components: {
    HubOrderCancelModal,
  },
  props: {
    orderInfo: {
      type: Object,
    },
  },
  data() {
    return {
      showCancelModal: false,
    };
  },
  computed: {
    hubStatusText() {
      let { hubStatusText } = this.orderInfo || {};
      return hubStatusText;
    },
    hubStatusDesc() {
      let { hubStatusDesc } = this.orderInfo || {};
      return hubStatusDesc;
    },
    hubCancelModalDesc() {
      const { hubCancelModalDesc } = this.orderInfo || {};
      return hubCancelModalDesc || "";
    },
    isDispatching() {
      const { isDispatching } = this.orderInfo || {};
      return isDispatching;
    },
  },
  watch: {
    hubCancelModalDesc: {
      immediate: true,
      handler(val, oldVal) {
        if (!oldVal && val) {
          this.showCancelModal = true;
        } else {
          this.showCancelModal = false;
        }
      },
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.hub-running-dispatching {
  display: flex;
  justify-content: space-between;
  padding: 14px 10px 0 20px;
  .left {
    flex: 1;
  }

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: #000000;
    line-height: 25px;
    padding-top: 6px;
    ::v-deep .subtitle {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #000000;
      line-height: 20px;
      margin-left: 7px;
    }

    ::v-deep .blue {
      font-family: DINAlternate, DINAlternate;
      font-weight: 500;
      font-size: 24px;
      color: #006efa;
      line-height: 28px;
    }
  }

  .desc {
    font-family: PingFangSC, PingFang SC;
    font-size: 11px;
    color: #00000099;
    line-height: 16px;
    margin-top: 3px;
    ::v-deep .blue {
      color: #006efa;
      font-weight: 500;
    }
  }

  .stop {
    width: 44px;
    height: 72px;
    transform: scaleX(-1);
  }
  .bus {
    width: 60px;
    height: 33px;
    margin-left: -20px;
    transform: scaleX(-1);
  }
}
</style>
